'use client';

import { c as _c } from "react/compiler-runtime";
import { type ReactNode } from 'react';
import { LocalizedLink } from '@src/components/LocalizedLink/LocalizedLink';
import { useClickAction } from '@src/hooks/useClickAction/useClickAction';
import { type ActionName, type AnalyticsEvents } from '@src/hooks/useClickAction/useClickAction.builder';
import { type UseClickActionArgs } from '@src/hooks/useClickAction/useClickActionArgs';
import { filterBuilderAttributes, getBuilderPreviewMode } from '@src/utils/builder.util';
import { cn } from '@src/utils/tailwind';
export type ActionLinkProps = UseClickActionArgs & {
  actionName?: ActionName;
  analyticsEvent?: (typeof AnalyticsEvents)[number];
  children?: ReactNode;
  className?: string;
};
export const ActionLink = props => {
  const $ = _c(17);
  const {
    children,
    attributes
  } = props;
  const {
    edit
  } = getBuilderPreviewMode();
  const {
    renderVideo,
    handlers
  } = useClickAction(props);
  const actionName = props.actionName;
  const isWrapping = actionName === "navigate";
  let t0;
  if ($[0] !== actionName || $[1] !== isWrapping) {
    t0 = !isWrapping && actionName && actionName !== "none" ? {
      role: "button",
      tabIndex: 0
    } : {};
    $[0] = actionName;
    $[1] = isWrapping;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const divButtonProps = t0;
  const t1 = cn("cursor-pointer", {
    "border-4 border-dotted border-sky-500": edit
  }, props.className);
  let t2;
  if ($[3] !== attributes || $[4] !== children || $[5] !== divButtonProps || $[6] !== handlers || $[7] !== isWrapping || $[8] !== props.navigate?.href || $[9] !== props.navigate?.target) {
    t2 = isWrapping ? <LocalizedLink {...filterBuilderAttributes(attributes)} {...handlers} href={props.navigate?.href ?? ""} target={props.navigate?.target}>{children}</LocalizedLink> : <div {...divButtonProps} {...handlers}>{children}</div>;
    $[3] = attributes;
    $[4] = children;
    $[5] = divButtonProps;
    $[6] = handlers;
    $[7] = isWrapping;
    $[8] = props.navigate?.href;
    $[9] = props.navigate?.target;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  let t3;
  if ($[11] !== renderVideo) {
    t3 = renderVideo();
    $[11] = renderVideo;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] !== t1 || $[14] !== t2 || $[15] !== t3) {
    t4 = <div className={t1}>{t2}{t3}</div>;
    $[13] = t1;
    $[14] = t2;
    $[15] = t3;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  return t4;
};